import { createRouter, createWebHistory } from "vue-router";
import { useAppStore } from "./stores/app";

const routes = [
  { path: "/login", component: () => import("./views/LoginView.vue"), meta: { public: true } },
  { path: "/change-password", component: () => import("./views/ChangePasswordView.vue") },
  { path: "/a/:slug", component: () => import("./views/PublicAgentView.vue"), meta: { public: true } },
  { path: "/shared/reports/:token", component: () => import("./views/SharedReportView.vue"), meta: { public: true } },
  { path: "/", component: () => import("./layouts/AdminLayout.vue"), children: [
    { path: "", redirect: "/overview" },
    { path: "overview", component: () => import("./views/OverviewView.vue") },
    { path: "projects", component: () => import("./views/ProjectsView.vue") },
    { path: "data-sources", component: () => import("./views/DataSourcesView.vue") },
    { path: "knowledge", component: () => import("./views/KnowledgeView.vue") },
    { path: "agent-config", component: () => import("./views/AgentConfigView.vue") },
    { path: "agent-debug", component: () => import("./views/AgentDebugView.vue") },
    { path: "reports", component: () => import("./views/ReportsView.vue") },
    { path: "reports/:id", component: () => import("./views/ReportDetailView.vue") },
    { path: "organization/members", component: () => import("./views/MembersView.vue") },
    { path: "organization/roles", component: () => import("./views/RolesView.vue") },
    { path: "platform/organizations", component: () => import("./views/OrganizationsView.vue") },
    { path: "platform/menus", component: () => import("./views/MenusView.vue") },
    { path: "platform/models", component: () => import("./views/ModelsView.vue") },
    { path: "platform/storage", component: () => import("./views/StorageView.vue") },
    { path: "platform/audit", component: () => import("./views/AuditView.vue") },
  ] },
];

const router = createRouter({ history: createWebHistory(), routes });
router.beforeEach(async (to) => {
  if (to.meta.public) return true;
  const store = useAppStore();
  if (!store.user) { try { await store.load(); } catch { return { path: "/login", query: { redirect: to.fullPath } }; } }
  if (store.user?.mustChangePassword && to.path !== "/change-password") return "/change-password";
  return true;
});
export default router;
